import { render, staticRenderFns } from "./bulletinBoardDemo.vue?vue&type=template&id=7986089e&scoped=true"
import script from "./bulletinBoardDemo.vue?vue&type=script&lang=js"
export * from "./bulletinBoardDemo.vue?vue&type=script&lang=js"
import style0 from "./bulletinBoardDemo.vue?vue&type=style&index=0&id=7986089e&prod&lang=less&scoped=true"
import style1 from "./bulletinBoardDemo.vue?vue&type=style&index=1&id=7986089e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7986089e",
  null
  
)

export default component.exports